"use client";

import { useRouter } from "next/navigation";
import ContactCommandCenter from "@/components/home/ContactCommandCenter";

interface HomeContactFormProps {
  id?: string;
}

export default function HomeContactForm({ id }: HomeContactFormProps) {
  const router = useRouter();

  return (
      <ContactCommandCenter
        id={id}
        onSubmit={async (data) => {
        const payload = {
          company: data.company || null,
          name: data.full_name || null,
          country: 'IN',
          phone: data.phone || null,
          email: data.email || null,
          message: data.message || null,
          requestType: data.subject || null,
        };

        const res = await fetch("/api/contact", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const result = await res.json();
          throw new Error(result.error || "Something went wrong");
        }
      }}
      onSuccess={() => router.push("/contact/thank-you")}
    />
  );
}
